/**
 * 动态加载外部脚本
 * @param {string} src - 脚本地址
 * @returns {Promise} - 脚本加载完成后的Promise
 */
export function loadScript(src) {
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

// 添加全局变量存储设备ID
let globalDeviceId = "";
let sdkInitialized = false;
let sdkInitPromise = null;

/**
 * 初始化登录SDK
 * @returns {Promise} - SDK初始化完成后的Promise
 */
export function initLoginSDK() {
  if (sdkInitialized) return Promise.resolve();
  if (sdkInitPromise) return sdkInitPromise;

  const currentUrl = window.location.href;
  const isQz = currentUrl.includes("qz100.com");
  let sdkUrl;
  let env;

  // 根据URL判断使用测试环境还是生产环境
  if (currentUrl.includes("test-")) {
    env = "sandbox";
    sdkUrl =
      "https://test-ucres.100tal.com/libs/jssdk/passport@1.27.08/passport.js?t=20260202";
  } else {
    env = "production";
    sdkUrl =
      "https://ucres.100tal.com/libs/jssdk/passport@1.27.08/passport.js?t=20260202";
  }

  // 加载脚本并返回Promise
  sdkInitPromise = loadScript(sdkUrl)
    .then(() => {
      console.log("登录SDK加载成功");
      if (window.TAL_UC) {
        window.TAL_UC.rankConfig({
          "client-id": isQz ? "391101" : "251101",
          env: env,
          entity: 1,
          domain: "",
          loginout_callback: function (res) {
            console.log(res, "=== 未登录/登录失效统一处理回调方法 =======");
          },
        });

        setTimeout(() => {
          window.TAL_UC.configNVC({
            renderToEle: "#captcha",
            isH5: false,
            onloadCallback: function () {
              console.log("滑块配置完成");
            },
            failCallback: function () {
              console.log("滑块配置失败");
            },
          });
        }, 500);

        return new Promise((resolve) => {
          if (typeof window.TAL_UC.getDeviceInfo === "function") {
            window.TAL_UC.getDeviceInfo({
              success: (res) => {
                if (res && res.data && res.data["d-id"]) {
                  globalDeviceId = res.data["d-id"];
                  console.log("获取设备ID成功:", globalDeviceId);
                } else {
                  console.warn("设备ID获取失败或为空");
                }
                resolve();
              },
              fail: (error) => {
                console.error("获取设备ID失败:", error);
                resolve();
              },
            });
          } else {
            console.warn("getDeviceInfo方法不可用");
            resolve();
          }
        }).then(() => {
          sdkInitialized = true;
          console.log("登录SDK和无痕验证初始化成功");
        });
      } else {
        console.error("TAL_UC不存在，SDK可能未正确加载");
        return Promise.reject(new Error("SDK初始化失败"));
      }
    })
    .catch((error) => {
      sdkInitPromise = null; // 失败时清除，允许重试
      console.error("登录SDK加载失败:", error);
      return Promise.reject(error);
    });

  return sdkInitPromise;
}

/**
 * 处理API调用中的滑块验证
 * @param {string} methodName - 调用的方法名
 * @param {Object} methodParams - 方法的参数对象
 * @param {Function} onSuccess - 方法成功回调
 * @param {Function} onFail - 方法失败回调
 */
export function handleAPIWithSlideVerification(
  methodName,
  methodParams,
  onSuccess,
  onFail
) {
  // 创建API调用参数
  console.log("handleAPIWithSlideVerification-->111", methodName, methodParams);
  var apiParams = {
    data: methodParams,
    success: function (res) {
      console.log("handleAPIWithSlideVerification-->", res);
      // 检查是否需要滑块验证
      if (res.errcode === 11021) {
        console.log(`${methodName} 需要滑块验证`);

        // 构建滑块验证参数
        var _params = {
          slideCallback: methodName, // 滑动验证通过后执行的方法名
          slideParams: apiParams, // 滑动验证通过后执行方法的/参数
          failCallback: function (error) {
            console.error("滑块验证失败:", error);
            // if (onFail) onFail(error);
          },
        };
        console.log("滑块验证参数:", _params, apiParams);
        // 显示滑块
        try {
          console.log(window.TAL_UC);
          console.log('111',window.TAL_UC.showSlide(_params));
        console.log('captcha--->',document.getElementById("captcha")); // 显示滑块容器
          window.TAL_UC.showSlide(_params);
        } catch (error) {
          console.error("显示滑块失败:", error);
        }

        return; // 退出当前函数，等待滑块验证完成
      } else if (res.errcode === 0) {
        // 直接返回成功结果
        if (onSuccess) onSuccess(res);
      } else {
        if (onFail) onFail(res);
      }
    },
    fail: function (error) {
      console.error(`${methodName} 调用失败:`, error);
      if (onFail) onFail(error);
    },
  };

  // 调用对应的API方法
  if (window.TAL_UC && typeof window.TAL_UC[methodName] === "function") {
    window.TAL_UC[methodName](apiParams);
  } else {
    console.error(`方法 ${methodName} 不存在或不可用`);
    if (onFail)
      onFail({ errcode: -1, errmsg: `方法 ${methodName} 不存在或不可用` });
  }
}

/**
 * 检查手机号格式是否正确
 * @param {string} phone - 手机号码
 * @returns {boolean} - 是否合法
 */
export function isValidPhone(phone) {
  return /^\d{11}$/.test(phone);
}

/**
 * 检查验证码格式是否正确
 * @param {string} code - 验证码
 * @returns {boolean} - 是否合法
 */
export function isValidVerificationCode(code) {
  return /^\d{4,6}$/.test(code);
}

/**
 * 设置cookie
 * @param {string} name - cookie名称
 * @param {string} value - cookie值
 * @param {number} days - 有效天数
 */
export function setCookie(name, value, days = 30) {
  // 获取当前域名并处理为.domain.com格式
  const hostname = window.location.hostname;
  let domain = hostname;

  // 如果不是IP地址，则转换为.domain.com格式
  if (!isIpAddress(hostname)) {
    const parts = hostname.split(".");
    if (parts.length > 1) {
      // 获取顶级域名，例如从www.kmf.com得到.kmf.com
      domain = "." + parts.slice(-2).join(".");
    }
  }

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires.toUTCString()}; domain=${domain}; path=/; SameSite=Lax`;
}

/**
 * 判断是否为IP地址
 * @param {string} hostname - 主机名
 * @returns {boolean} - 是否为IP地址
 */
function isIpAddress(hostname) {
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);
}

/**
 * 登录成功后发送code到后端接口
 * @param {string} code - 登录成功后返回的code
 * @returns {Promise} - 请求结果的Promise
 */
export async function sendLoginCodeRequest(code) {
  try {
    // 使用全局保存的设备ID，不再在此处获取
    const deviceId = globalDeviceId;

    // 确定请求URL
    const currentUrl = window.location.href;
    const isQz = currentUrl.includes("qz100.com");
    const apiDomain = isQz ? "api.qz100.com" : "api.kmf.com";
    const baseUrl = currentUrl.includes("test-")
      ? "https://test-" + apiDomain
      : "https://" + apiDomain;
    const apiUrl = isQz
      ? `${baseUrl}/api-user/user/login/code`
      : `${baseUrl}/api-passport/tal/udc/login/code`;

    // 发送请求
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "K-Client-Id": isQz ? "391101" : "251101",
        "K-Device-Id": deviceId,
      },
      body: JSON.stringify({ code }),
    });

    const data = await response.json();
    console.log("登录code请求成功:", data);

    // 如果响应中包含auth_token，则写入cookie
    if (data && data.result && data.result.auth_token) {
      setCookie("authkey", data.result.auth_token);
      console.log("已将authkey写入cookie，有效期30天");
    } else {
      console.warn("响应数据中不包含authkey");
    }

    return data;
  } catch (error) {
    console.error("登录code请求失败:", error);
    throw error;
  }
}
